"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggleClient = exports.DisabledLaunchDarklyClient = void 0;
/**
* @copyright (c) 2024 Bentley Systems, Incorporated. All rights reserved.
*/
var launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");
/**
 * For local development only
 */
var DisabledLaunchDarklyClient = /** @class */ (function () {
    function DisabledLaunchDarklyClient() {
    }
    DisabledLaunchDarklyClient.prototype.alias = function (user, previousUser) { };
    DisabledLaunchDarklyClient.prototype.close = function (onDone) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve()];
        }); });
    };
    DisabledLaunchDarklyClient.prototype.waitUntilGoalsReady = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve()];
        }); });
    };
    DisabledLaunchDarklyClient.prototype.getUser = function () { return {}; };
    DisabledLaunchDarklyClient.prototype.setStreaming = function (value) { };
    DisabledLaunchDarklyClient.prototype.waitUntilReady = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve()];
        }); });
    };
    DisabledLaunchDarklyClient.prototype.waitForInitialization = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve()];
        }); });
    };
    DisabledLaunchDarklyClient.prototype.identify = function (user, hash, onDone) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve({})];
        }); });
    };
    DisabledLaunchDarklyClient.prototype.flush = function (onDone) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve()];
        }); });
    };
    DisabledLaunchDarklyClient.prototype.variation = function (key, defaultValue) { return defaultValue; };
    DisabledLaunchDarklyClient.prototype.variationDetail = function (key, defaultValue) { return {}; };
    DisabledLaunchDarklyClient.prototype.on = function (key, callback, context) { };
    DisabledLaunchDarklyClient.prototype.off = function (key, callback, context) { };
    DisabledLaunchDarklyClient.prototype.track = function (key, data) { };
    DisabledLaunchDarklyClient.prototype.allFlags = function () { return {}; };
    return DisabledLaunchDarklyClient;
}());
exports.DisabledLaunchDarklyClient = DisabledLaunchDarklyClient;
/**
 * LaunchDarkly wrapper. To initialize call initializeClient or initializeDisabledClient for local development
 * @see initializeClient
 * @see initializeDisabledClient
 */
var FeatureToggleClient = /** @class */ (function () {
    function FeatureToggleClient() {
        this._isError = false;
        this._isLoading = true;
        // Need to have a reference to mock on tests
        this.initialize = launchdarkly_js_client_sdk_1.initialize;
    }
    /**
     * @param {String} clientSideId LaunchDarkly client-side ID
     * @param {FeatureToggleUser} featureToggleUser User data required for LaunchDarkly
     * @param {LDOptions} [options] LaunchDarkly options
     * @returns {Promise<void>} Promise that is resolved when LaunchDarkly is initialized and rejected when fails
     */
    FeatureToggleClient.prototype.initializeClient = function (clientSideId, featureToggleUser, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!clientSideId) {
                    this._isLoading = false;
                    this._isError = true;
                    return [2 /*return*/, Promise.reject('clientSideId is missing.')];
                }
                this._launchDarklyClient = this.initialize(clientSideId, this.convertToLDUser(featureToggleUser), options);
                return [2 /*return*/, this._launchDarklyClient.waitForInitialization()
                        .then(function () {
                        _this._isLoading = false;
                    })
                        .catch(function (e) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            this._isError = true;
                            this._isLoading = false;
                            return [2 /*return*/, Promise.reject(e)];
                        });
                    }); })];
            });
        });
    };
    FeatureToggleClient.prototype.convertToLDUser = function (featureToggleUser) {
        var user = featureToggleUser || {};
        return {
            key: this.toUpperCase(user.id),
            name: this.toUpperCase(user.email),
            email: this.toUpperCase(user.email),
            custom: __assign({ UltimateId: !isNaN(user.ultimateSite) ? Number(user.ultimateSite) : 0, CountryIso: this.toUpperCase(user.countryIso), ImsId: this.toUpperCase(user.id) }, featureToggleUser === null || featureToggleUser === void 0 ? void 0 : featureToggleUser.custom),
        };
    };
    FeatureToggleClient.prototype.toUpperCase = function (str) {
        return str ? str.toUpperCase() : '';
    };
    /**
     * Initializes disabled LaunchDarkly client. Use this for local development or testing
     * @returns Resolved Promise
     */
    FeatureToggleClient.prototype.initializeDisabledClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._isLoading = false;
                this._launchDarklyClient = new DisabledLaunchDarklyClient();
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    /**
     * @param {String} flagName Feature flag name
     * @param {T} defaultValue The fallback value if LaunchDarkly is not accessible
     * @returns {T} Feature flag value from LaunchDarkly or default one if there is an error or client is not initialized yet
     */
    FeatureToggleClient.prototype.getVariation = function (flagName, defaultValue) {
        if (this._isError || this._isLoading) {
            return defaultValue;
        }
        return this._launchDarklyClient.variation(flagName, defaultValue);
    };
    return FeatureToggleClient;
}());
exports.FeatureToggleClient = FeatureToggleClient;
